import { render, staticRenderFns } from "./ButtonCamera.vue?vue&type=template&id=f65353fe&scoped=true"
import script from "./ButtonCamera.vue?vue&type=script&lang=js"
export * from "./ButtonCamera.vue?vue&type=script&lang=js"
import style0 from "./ButtonCamera.vue?vue&type=style&index=0&id=f65353fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65353fe",
  null
  
)

export default component.exports